function NotFound() {
    return (
        <>
        <h3>Page Not Found!</h3>
        </>
    );
}

export default NotFound;